// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small .role[data-v-2a8f5cc2]{font-size:11px;color:#ccc}.active .small .role[data-v-2a8f5cc2]{font-size:11px;color:#7c7c7c}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
